export default {
    getWishlist : [],
    searchData : []
}